var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading && _vm.show)?_c('v-container',{staticClass:"pa-0"},[_c('v-skeleton-loader',{staticClass:"elevation-1 mb-4",attrs:{"type":_vm.type}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }